import { useState } from "react";

import Skeleton from "react-loading-skeleton";

export function TextSkeleton() {
    // Random width gives the skeleton bars natural variation; compute once on
    // mount so render stays pure (stable across re-renders).
    const [width] = useState(() => Math.floor(Math.random() * 121) + 80);
    return <Skeleton enableAnimation height={18} width={width} />;
}
